import { render } from "./ClinicsMobile.vue?vue&type=template&id=8c3d0724&ts=true"
import script from "./ClinicsMobile.vue?vue&type=script&lang=ts"
export * from "./ClinicsMobile.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__